export default __webpack_public_path__ + "static/media/chart-selected.42d043c6.svg";